export default class SearcherStoreItem {
	_headerTitle;
	_buttonName;
	_selectionEmptyMessage;
	_modal;
	_closeButton;
	_filterValues;
	_results;
	_searcher;
	_page;
	_isLoading;

	constructor(storeItemProps = {}) {
		Object.keys(storeItemProps)
		.forEach((propName) => this[propName] = storeItemProps[propName]);
	}

	get headerTitle() {
		return this._headerTitle;
	}

	set headerTitle(value) {
		this._headerTitle = value;
	}

	get buttonName() {
		return this._buttonName;
	}

	set buttonName(value) {
		this._buttonName = value;
	}

	get selectionEmptyMessage() {
		return this._selectionEmptyMessage;
	}

	set selectionEmptyMessage(value) {
		this._selectionEmptyMessage = value;
	}

	get modal() {
		return this._modal;
	}

	set modal(value) {
		this._modal = value;
	}

	get closeButton() {
		return this._closeButton;
	}

	set closeButton(value) {
		this._closeButton = value;
	}

	get filterValues() {
		return this._filterValues;
	}

	set filterValues(value) {
		this._filterValues = value;
	}

	get results() {
		return this._results;
	}

	set results(value) {
		this._results = value;
	}

	get searcher() {
		return this._searcher;
	}

	set searcher(value) {
		this._searcher = value;
	}

	get page() {
		return this._page;
	}

	set page(value) {
		this._page = value;
	}

	get isLoading() {
		return this._isLoading;
	}

	set isLoading(value) {
		this._isLoading = value;
	}
}
